import React from "react";
import ItemSummary from "./itemsummary";
import "./itemsummary.scss";
import { IContainerProps } from "./itemsummaryinterface";

function ItemSummaryContainer(props: IContainerProps) {

    return (
        <ItemSummary
            itemSummaryDetails={props?.itemSummaryDetails}
        />
    );
}

export default ItemSummaryContainer;
